import React from 'react';
import { BannerVariant, DismissibleBannerProps } from './types';
import FloatingBanner from './variants/FloatingBanner';
import BaseBanner from './core/BaseBanner';

interface BannerProps extends DismissibleBannerProps {
  variant?: BannerVariant;
  onButtonClick?: () => void;
}

const Banner: React.FC<BannerProps> = props => {
  const variant = props.variant || 'floating';

  switch (variant) {
  case 'floating':
    return <FloatingBanner {...(props as BannerProps)} />;
      
    
  default:
    return <BaseBanner {...(props as BannerProps)} />;
  }
};

export type { 
  BannerVariant, 
  DismissibleBannerProps,
} from './types';

export type { BannerProps };

export interface BannerConfig {
  title?: string;
  message?: string;
  buttonText?: string;
  isVisible?: boolean;
  showIcon?: boolean;
  showCloseButton?: boolean;
  severity?: 'error' | 'warning' | 'info' | 'success';
  icon?: React.ReactNode;
}

export default Banner; 